// app/src/lib/brand.ts — the single place a deployment's identity lives.
// A rebrand (e.g. the Al Badar Autos install) edits THIS file; functional code
// imports from here instead of hardcoding the shop name, host or currency glyph.
// Marketing prose on the public site is managed in Website → Content, not here.
export const BRAND_NAME = "Slough Scooters";
export const BRAND_LEGAL = "Slough Scooters LTD";
/** Hostnames that serve the public marketing site (the EPOS runs on the login subdomain). */
export const PUBLIC_HOST_RE = /^(www\.|uk\.)?sloughscooters\.com$/i;
/** uk. is the QR catalogue: the same app, but only the shop, ordering, tracking
 *  and account — no marketing pages. Kept separate from the main website so a
 *  scanned label lands on something to buy, not a homepage. */
export const CATALOGUE_HOST_RE = /^uk\.sloughscooters\.com$/i;
/** Display glyph for prices on the public site (the EPOS itself reads the org's currency). */
export const CURRENCY = "£";
